<div class="homeContainer">
    <div class="frontImageContainer">
        <img src="https://www.foxline.ro/Images/automation_home.jpg"/>
    </div>
</div>